import { CssProperties } from "src/models/css-property";
import { WidgetAnimationRenderer } from "../widget-animation.renderer";
import { ElementStyleService } from "../../../services/element-style.service";
import { IStoreSubscriptionsWidgetStyle } from "src/typings/store-subscriptions-widget-data";

export class StoreSubscriptionsStyleRenderer {

    private readonly animationRenderer: WidgetAnimationRenderer;

    constructor(private readonly styleService: ElementStyleService) {
        this.animationRenderer = new WidgetAnimationRenderer(this.styleService);
    }

    public render(element: HTMLElement, style: IStoreSubscriptionsWidgetStyle): void {
        this.renderCommon(element, style);
    }

    private renderCommon(element: HTMLElement, style: IStoreSubscriptionsWidgetStyle): void {
        const styles = new CssProperties();

        if (style.font.family) {
            styles.add("font-family", style.font.family);
        }

        if (style.font.weight) {
            styles.add("font-weight", style.font.weight);
        }

        this.styleService.setStyle(element, `#${element.id} .widget-content`, styles.data);
    }

}
